"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayContent = exports.OverlayContentWrap = exports.Wrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _mediaQueries = _interopRequireDefault(require("../../utils/media-queries"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    width: 100%;\n    ", "\n    vertical-align: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    height: 100%;\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    animation-name: ", ";\n    animation-duration: 0.35s;\n    padding: 24px 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    animation-name: ", ";\n    animation-duration: 0.35s;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var fade = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
var slide = (0, _styledComponents.keyframes)(["0%{transform:translate3d(0,5%,0);opacity:0;}70%{opacity:1;}100%{transform:translate3d(0,0,0);}"]);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "ouzm34-0"
})(["background:rgba(34,34,34,0.85);position:fixed;overflow-y:scroll;overflow-x:hidden;height:100%;width:100%;z-index:10;top:0;bottom:0;left:0;right:0;opacity:1;-webkit-overflow-scrolling:touch;-webkit-tap-highlight-color:transparent;", " ", ""], _mediaQueries["default"].desktop(_templateObject(), fade), _mediaQueries["default"].mobile(_templateObject2(), function (props) {
  return props.isOnBottom ? '' : 'background: white;';
}));

exports.Wrapper = Wrapper;

var OverlayContentWrap = _styledComponents["default"].div.withConfig({
  displayName: "styled__OverlayContentWrap",
  componentId: "ouzm34-1"
})(["height:100%;width:100%;opacity:1;padding-top:0;text-align:center;", " ", " &:before{content:'';display:inline-block;vertical-align:middle;height:100%;}"], _mediaQueries["default"].desktop(_templateObject3(), slide), _mediaQueries["default"].mobile(_templateObject4(), function (props) {
  return props.isOnBottom ? '' : 'background: white;';
}));

exports.OverlayContentWrap = OverlayContentWrap;

var OverlayContent = _styledComponents["default"].div.withConfig({
  displayName: "styled__OverlayContent",
  componentId: "ouzm34-2"
})(["display:inline-flex;justify-content:center;vertical-align:middle;text-align:left;cursor:auto;", ""], _mediaQueries["default"].mobile(_templateObject5(), function (props) {
  return props.isOnBottom ? '' : 'min-height: 100%;';
}, function (props) {
  return props.isOnBottom ? 'bottom' : 'top';
}));

exports.OverlayContent = OverlayContent;